import React, { useEffect, useMemo, useState } from 'react';
import { DeleteIcon } from 'tdesign-icons-react';
import { Button, Drawer, Link, Loading, MessagePlugin, Popconfirm, Tabs } from 'tdesign-react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { useMemoizedFn } from 'ahooks';
import ModalHeader from '@/components/Header/Modal';
import { fetchTopicDetailOverview, resetDetail } from '@/slices/kopTopicSlice';
import { delTopic } from '@/services/kopTopicService';
import PermWrapper from '@/components/PermWrapper';
import { isKafkaCluster } from '@/pages/Layout/MenuLayout/CulsterAddon';
import Summary from './Summary';
import Partition from './Partition';
import Message from './Message';
import ConsumerGroups from './ConsumerGroups';
import Configuration from './Configuration';
import AddPartionModal from './AddPartionModal';
import KafkaACLs from './KafkaACLs';
import KopACLs from './KopACLs';

const { TabPanel } = Tabs;

function Detail({
  loading,
  topic,
  clusterName,
  fetchTopicDetailOverview,
  onRefresh,
  resetDetail,
  overview,
  isKafka,
}) {
  const [visible, setVisible] = useState(false);
  const [currentTab, setCurrentTab] = useState(1);
  const [visiblePartion, setVisiblePartion] = useState(false);

  const loadDetail = useMemoizedFn(async () => {
    fetchTopicDetailOverview({
      clusterName,
      topic,
    });
  });

  useEffect(() => {
    if (visible) {
      loadDetail();
    }

    if (!visible) {
      resetDetail();
      setCurrentTab(1);
    }
  }, [loadDetail, visible, resetDetail]);

  const handleDelete = async () => {
    await delTopic({
      clusterName,
      topic,
    });
    MessagePlugin.success('删除成功！');
    setVisible(false);
    onRefresh();
  };

  const onClose = () => setVisible(false);

  const commonProps = useMemo(
    () => ({
      clusterName,
      topic,
    }),
    [clusterName, topic],
  );

  const footer = (
    <Footer>
      <PermWrapper resource='kop:topic:list:dilatation'>
        <Button onClick={() => setVisiblePartion(true)} theme='primary'>
          分区扩容
        </Button>
      </PermWrapper>
    </Footer>
  );

  return (
    <>
      <Link theme='primary' style={{ wordBreak: 'break-all' }} onClick={() => setVisible(true)}>
        {topic}
      </Link>
      <Drawer
        size={1200}
        destroyOnClose
        header={
          <ModalHeader
            tags={[clusterName, topic]}
            tail={
              <PermWrapper resource='kop:topic:list:delete'>
                <Popconfirm theme='danger' content='确定删除？' onConfirm={handleDelete}>
                  <Button theme='danger' variant='outline' size='small' icon={<DeleteIcon />}>
                    删除
                  </Button>
                </Popconfirm>
              </PermWrapper>
            }
          >
            Topic
          </ModalHeader>
        }
        visible={visible}
        onClose={onClose}
        footer={currentTab === 1 ? footer : null}
      >
        {visible && (
          <Loading loading={loading} size='small'>
            <Root>
              <Summary />

              <Tabs value={currentTab} onChange={setCurrentTab}>
                <TabPanel value={1} destroyOnHide label='Partitions'>
                  <Partition commonProps={commonProps} />
                </TabPanel>
                <TabPanel value={2} destroyOnHide label='Messages'>
                  <Message commonProps={commonProps} />
                </TabPanel>
                <TabPanel value={3} destroyOnHide label='ConsumerGroups'>
                  <ConsumerGroups commonProps={commonProps} />
                </TabPanel>
                <TabPanel value={4} destroyOnHide label='ACLS'>
                  {isKafka ? (
                    <KafkaACLs commonProps={commonProps} />
                  ) : (
                    <KopACLs commonProps={commonProps} />
                  )}
                </TabPanel>
                <TabPanel value={5} destroyOnHide label='Configuration'>
                  <Configuration commonProps={commonProps} />
                </TabPanel>
              </Tabs>
            </Root>
          </Loading>
        )}
      </Drawer>
      <AddPartionModal
        overview={overview}
        visible={visiblePartion}
        handleClose={() => setVisiblePartion(false)}
      />
    </>
  );
}

export default connect(
  (state) => ({
    overview: state.kopTopic.detailOverview,
    loading: state.kopTopic.loading,
    isKafka: isKafkaCluster(state.kopCluster.allList), // 判断是不是kafka节点集群
  }),
  {
    fetchTopicDetailOverview,
    resetDetail,
  },
)(Detail);

const Root = styled.div`
  margin-top: -15px;
`;

const Footer = styled.div`
  padding-left: 10px;
`;
